module.exports = __webpack_public_path__ + "09d0b9ce3c31f5788cf8a137bb679d3d.svg";